import { Injectable } from "@angular/core";

import { ObgSidenav } from "./sidenav.model";

@Injectable({
	providedIn: "root",
})
export class SidenavService {
	private navs: ObgSidenav[] = [];

	set(navs: ObgSidenav[]) {
		this.navs = navs;
	}

	open(id: string) {
		const nav = this.findSidenav(id);
		if (nav && !nav.disabled) {
			nav.open();
		}
	}

	close(id: string) {
		this.findSidenav(id)?.close();
	}

	toggle(id: string) {
		this.findSidenav(id)?.toggle();
	}

	closeAll() {
		this.navs.forEach((sidenav) => sidenav.close());
	}

	isAnyOpen(): boolean {
		return this.navs.some((sidenav) => sidenav.isOpen());
	}

	enable(id: string) {
		const nav = this.findSidenav(id);
		if (nav) {
			nav.disabled = false;
		}
	}

	disable(id: string) {
		const nav = this.findSidenav(id);
		if (nav) {
			nav.disabled = true;
		}
	}

	private findSidenav(id: string): ObgSidenav | undefined {
		return this.navs.find((s) => s.id === id);
	}
}
